import React from 'react';
var HeaderNavList = function (_a) {
    var children = _a.children;
    return (React.createElement("ul", { className: "fr-nav__list" }, Array.isArray(children) ?
        children.map(function (child, key) { return (React.createElement("li", { key: "navLink" + key, className: "fr-nav__item" }, child)); })
        : (React.createElement("li", { className: "fr-nav__item" }, children))));
};
export default HeaderNavList;
